"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
let Parse;
Parse = require("parse");
const Request_1 = require("./constants/Request");
const Keys_1 = require("./constants/Keys");
const Track_1 = require("./Track");
const login = (username, code) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    return new Promise((resolve, reject) => {
      Parse.User.logIn(username, code).then(user => __awaiter(void 0, void 0, void 0, function* () {
        const query = new Parse.Query(Parse.Session);
        if (user.get("Residence") !== undefined) {
          query.include("user.Residence");
        }
        const session = yield query.first();
        const sessionToken = session.get("sessionToken");
        Keys_1.default.setToken(sessionToken);
        //Track on Mixpanel
        const userJSON = user.toJSON();
        Track_1.default.updatePeople(userJSON);
        Track_1.default.event({
          event: "login",
          user: userJSON
        });
        resolve({
          data: userJSON
        });
      })).catch(e => {
        console.error(e);
        reject(e);
      });
    });
  } catch (e) {
    console.error(e);
    return e;
  }
});
const register = params => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise((resolve, reject) => {
    Request_1.default.post("/v4/volunteer/register", params).then(result => {
      //Track on Mixpanel
      Track_1.default.updatePeople(result.data.User);
      if (!result.data.isLogin) Track_1.default.event({
        event: "register",
        user: result.data.User
      });
      resolve(result);
    }).catch(e => {
      reject(e);
    });
  });
});
const sendCode = params => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise((resolve, reject) => {
    Request_1.default.get("/v4/volunteer/login", {
      objectId: params.userId,
      phone: params.phone,
      type: params.type,
      sendSMS: params.sendSMS
    }).then(result => {
      Track_1.default.event({
        event: "code sent",
        user: result
      });
      resolve(result);
    }).catch(e => {
      reject(e);
    });
  });
});
const logout = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const result = yield Parse.User.logOut();
    Track_1.default.event({
      event: "logout",
      user: result
    });
    return {
      data: result
    };
  } catch (e) {
    return e;
  }
});
exports.default = {
  login,
  register,
  sendCode,
  logout
};